import endpoints from '../../config/endpoints';
import { Sidebar } from "../../layouts/Sidebar";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AddYear = () => {
  const [greg, setGreg] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const send = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(endpoints.year, true).post({
      greg: greg
    })
    
    if(res.code == 201){
      Swal.fire({
        title: 'موفق',
        text: 'سال با موفقیت ساخته شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate('/year')
        }
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }
    
    dispatch(setLoading(false));
  }
  
  return (
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
            ایجاد سال
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه لیست سال</h1>
             <h1 className="dashBoardTitle">افزودن سال جدید</h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate("/year/")}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle"> اطلاعات سال</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoAmount">سال میلادی</label>
            <input className="addInput" placeholder="سال میلادی" id="infoAmount" onChange={(input: any) => setGreg(input.target.value)}/>
          </form>
        </section>
      </main>
      </body>
    </>
  )
}
export default AddYear;